/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NftOwnershipMatrix } from './NftOwnershipMatrix';
import {
    NftOwnershipMatrixFromJSON,
    NftOwnershipMatrixFromJSONTyped,
    NftOwnershipMatrixToJSON,
    NftOwnershipMatrixToJSONTyped,
} from './NftOwnershipMatrix';
import type { NftGrouping } from './NftGrouping';
import {
    NftGroupingFromJSON,
    NftGroupingFromJSONTyped,
    NftGroupingToJSON,
    NftGroupingToJSONTyped,
} from './NftGrouping';
import type { NftTracker } from './NftTracker';
import {
    NftTrackerFromJSON,
    NftTrackerFromJSONTyped,
    NftTrackerToJSON,
    NftTrackerToJSONTyped,
} from './NftTracker';

/**
 * Represents a collection of the trackers and groupings and their corresponding information in regards to ownership of users.
 * @export
 * @interface NftOwnershipInformation
 */
export interface NftOwnershipInformation {
    /**
     * 
     * @type {Array<string>}
     * @memberof NftOwnershipInformation
     */
    userIds: Array<string>;
    /**
     * 
     * @type {Array<NftOwnershipMatrix>}
     * @memberof NftOwnershipInformation
     */
    nftOwnerships: Array<NftOwnershipMatrix>;
    /**
     * 
     * @type {Array<NftGrouping>}
     * @memberof NftOwnershipInformation
     */
    myGroupings: Array<NftGrouping>;
    /**
     * 
     * @type {Array<NftGrouping>}
     * @memberof NftOwnershipInformation
     */
    nftGroupings: Array<NftGrouping>;
    /**
     * 
     * @type {Array<NftTracker>}
     * @memberof NftOwnershipInformation
     */
    nftTrackers: Array<NftTracker>;
}

/**
 * Check if a given object implements the NftOwnershipInformation interface.
 */
export function instanceOfNftOwnershipInformation(value: object): value is NftOwnershipInformation {
    if (!('userIds' in value) || value['userIds'] === undefined) return false;
    if (!('nftOwnerships' in value) || value['nftOwnerships'] === undefined) return false;
    if (!('myGroupings' in value) || value['myGroupings'] === undefined) return false;
    if (!('nftGroupings' in value) || value['nftGroupings'] === undefined) return false;
    if (!('nftTrackers' in value) || value['nftTrackers'] === undefined) return false;
    return true;
}

export function NftOwnershipInformationFromJSON(json: any): NftOwnershipInformation {
    return NftOwnershipInformationFromJSONTyped(json, false);
}

export function NftOwnershipInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftOwnershipInformation {
    if (json == null) {
        return json;
    }
    return {
        
        'userIds': json['userIds'],
        'nftOwnerships': ((json['nftOwnerships'] as Array<any>).map(NftOwnershipMatrixFromJSON)),
        'myGroupings': ((json['myGroupings'] as Array<any>).map(NftGroupingFromJSON)),
        'nftGroupings': ((json['nftGroupings'] as Array<any>).map(NftGroupingFromJSON)),
        'nftTrackers': ((json['nftTrackers'] as Array<any>).map(NftTrackerFromJSON)),
    };
}

export function NftOwnershipInformationToJSON(json: any): NftOwnershipInformation {
    return NftOwnershipInformationToJSONTyped(json, false);
}

export function NftOwnershipInformationToJSONTyped(value?: NftOwnershipInformation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userIds': value['userIds'],
        'nftOwnerships': ((value['nftOwnerships'] as Array<any>).map(NftOwnershipMatrixToJSON)),
        'myGroupings': ((value['myGroupings'] as Array<any>).map(NftGroupingToJSON)),
        'nftGroupings': ((value['nftGroupings'] as Array<any>).map(NftGroupingToJSON)),
        'nftTrackers': ((value['nftTrackers'] as Array<any>).map(NftTrackerToJSON)),
    };
}

